/**
 * =============================================================
 * AADHAV ACADEMY – ADMIN FEE MASTER SLICE
 * Role: Admin
 * Scope: Redux state management for fee templates
 * Standard: Enterprise / MNC Level
 * =============================================================
 */

import { createSlice } from "@reduxjs/toolkit";
import { fetchFeeMasters } from "./fee_master.thunk";

const initialState = {
  feeMasters: [],
  loading: false,
  error: null,
};

const feeMasterSlice = createSlice({
  name: "feeMaster",
  initialState,
  reducers: {
    clearFeeMasterError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      /* ===== FETCH FEE MASTERS ===== */
      .addCase(fetchFeeMasters.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFeeMasters.fulfilled, (state, action) => {
        state.loading = false;
        state.feeMasters = action.payload;
      })
      .addCase(fetchFeeMasters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearFeeMasterError } = feeMasterSlice.actions;

export default feeMasterSlice.reducer;